export const isCalendlyEvent = (event: MessageEvent<any>) => {
  return event.data.event && event.data.event.indexOf('calendly') === 0
}
